import React from 'react'
import styled from 'styled-components'
import media from '@Styles/media'
import { theme } from '@Styles/config'

type props = { numberOfPosts: number; isOrg: boolean }

const PostSlab: React.FC<props> = (props: props) => {
  const { numberOfPosts, isOrg } = props
  return (
    <Container numberOfPosts={numberOfPosts}>
      <PostHeader>
        <PostIcon />
        <PostHeading>
          <TextShort />
          <TextShort />
          {isOrg ? <TextShort /> : null}
        </PostHeading>
      </PostHeader>

      <TextLong />
      <TextLong />
      {isOrg ? <TextShort /> : null}
      {isOrg ? <Image /> : null}
    </Container>
  )
}

export default PostSlab

const iconSize = 54

const PostHeader = styled.div`
  position: relative;
  flex: auto;
  margin-bottom: 50px;
  flex-direction: row;
  display: flex;
`

const PostHeading = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 7px;
`

const PostIcon = styled.div`
  width: ${iconSize}px;
  height: ${iconSize}px;
  margin-right: 18px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.placeholderColor};
  flex-shrink: 0;
`

const Post = styled.div`
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.placeholderColor};
  height: 12px;
`

const Image = styled.div`
  background-color: ${({ theme }) => theme.colors.placeholderColor};
  width: auto;
  margin: 20px -18px 0 -18px;
  height: 500px;
`

const TextLong = styled(Post)`
  width: 100%;
  margin-bottom: 20px;
  & + & {
    width: 80%;
  }
`

const TextShort = styled(Post)`
  width: 40%;
  margin: 0 60% 7px 0;
  & + & {
    margin: 0 4px 7px 0;
  }
`

const Container = styled.article<{ numberOfPosts: number }>`
  position: relative;
  margin: ${({ theme }) => theme.sizes.gutterDefault} 0;
  background-color: #fff;
  border-radius: 2px;
  width: 100%;
  box-shadow: ${({ theme }) => theme.colors.contentShadow};
  display: flex;
  padding: 18px;
  flex-direction: column;

  ${media.largeScreen`
    width: ${({ numberOfPosts }: any) => {
      return `calc(${100 / numberOfPosts}% - ${theme.sizes.gutterDefault})`
    }};
  `}

  ${media.mediumScreen`
    width: ${({ numberOfPosts }: any) => {
      return `calc(${100 / (numberOfPosts - 1)}% - ${theme.sizes.gutterDefault})`
    }};
  `}

  ${media.smallScreen`
    width: 100%;
  `}
`
